var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.lsIconClass,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 5.41 9.41"}},[_c('polygon',{attrs:{"fill":"#b2b5bb","points":"0.71 9.41 0 8.71 4 4.71 0 0.71 0.71 0 5.41 4.71 0.71 9.41"}})])}
var staticRenderFns = []

export { render, staticRenderFns }